<script setup>
/* Imports */
import {
  computed,
} from 'vue';

/* Helpers */
import { getReturnToShoppingUrl } from '../helpers/mainHelpers.js';

/* Store */
import { useGlobalStore } from '../store/global.js';

/* Init store */
const globalStore = useGlobalStore();

/* Compute the list of product IDs */
const pids = computed(() => {
  const products = globalStore.getProductData?.products;

  // Check if products is an array
  if (Array.isArray(products)) {
    return products?.map((el) => el?.pid);
  }
  // Handle the case where products is not an array (e.g., set pids to an empty array)
  return [];
});

/* Compute the return to shopping URL */
const returnToShoppingUrl = computed(() => getReturnToShoppingUrl({
  appOrigin: window?.location?.origin || 'https://www.garmin.com',
  locale: globalStore.getLocale,
  pids: pids.value,
}));
</script>

<template>
  <div class="app-header">
    <div class="container">
      <a
        :href="returnToShoppingUrl"
        target="_self"
        class="app-header__link"
        data-testid="product-compare-return-to-shopping-link"
        tabindex="0"
        @keydown.enter="returnToShoppingUrl"
        @keydown.space="returnToShoppingUrl"
      >
        <g-icon-arrow-right
          class="app-header__link__icon"
          data-testid="product-compare-return-to-shopping-icon"
        />
        {{ globalStore.getTranslations?.ITFE_PRODUCT_COMPARE_BACK_LINK_MESSAGE }}
      </a>
      <g-heading
        text-align="center"
        size="1"
        caseTransform="upper"
        :dataTestId="{
          host: 'product-compare-page-title-host',
        }"
      >
        <h1 v-html="globalStore.getTranslations?.ITFE_PRODUCT_COMPARE_PAGE_TITLE" />
      </g-heading>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-header {

  &__link {
    display: flex;
    align-items: center;
    font-size: $font-size-small;

    &__icon {
      width: 9px;
      height: 15px;
      transform: rotate(180deg);
      margin-right: 0.6rem;
    }
  }

  :deep(.g__heading) {

    h1 {
      margin: 2rem 0 0 0;

      @include breakpoint('sm') {
        margin: 1rem 0 0 0;
      }
    }
  }
}
</style>
